"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useRouter_1 = require("../../contexts/useRouter/useRouter");
const Title_1 = require("../../components/Title/Title");
const PanelSkills_1 = require("../../presenters/PanelSkills/PanelSkills");
const Search_1 = require("../../presenters/Search/Search");
const SkillList_styled_1 = require("./SkillList.styled");
const localization_1 = require("../../localization");
const SkillList = () => {
    const { navigate } = (0, useRouter_1.useRouter)();
    return ((0, jsx_runtime_1.jsxs)(SkillList_styled_1.SkillListStyled, { children: [(0, jsx_runtime_1.jsx)(Search_1.Search, { className: "search" }), (0, jsx_runtime_1.jsx)(Title_1.Title, { text: localization_1.localization.skill.list.text }), (0, jsx_runtime_1.jsx)(PanelSkills_1.PanelSkills, { className: "skills", onSkill: ((0, react_1.useCallback)((skill) => ((0, jsx_runtime_1.jsx)("button", { className: "skill", type: "button", onClick: () => navigate(`/skills/${skill.id}`), children: skill['attributes']['name'] }, skill.id)), [navigate])) })] }));
};
exports.SkillList = SkillList;
//# sourceMappingURL=SkillList.js.map